import type { Configuration } from '@azure/msal-browser';
import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

const clientId = (import.meta.env.VITE_AAD_CLIENT_ID || '').trim();
const authority = (import.meta.env.VITE_AAD_AUTHORITY || '').trim();
const rawScopes = (import.meta.env.VITE_AAD_SCOPES as string) || 'api://trapi/.default';

export function getMsalConfigurationError(): string | null {
  return !clientId || !authority
    ? 'Missing Azure AD configuration. Copy trapi-ui/.env.example to trapi-ui/.env or set VITE_AAD_CLIENT_ID and VITE_AAD_AUTHORITY before signing in.'
    : null;
}

export const defaultScopes = rawScopes
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean);

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
    },
  },
};

export const loginRequest = {
  scopes: defaultScopes,
  prompt: 'select_account' as const,
};

export const trapiTokenRequest = {
  scopes: defaultScopes,
};

export function createMsalInstance() {
  const msalConfigurationError = getMsalConfigurationError();
  if (msalConfigurationError) {
    throw new Error(msalConfigurationError);
  }

  return new PublicClientApplication(msalConfig);
}
